import { Link } from "@fluentui/react-components";
import pluralize from "pluralize";
import React, { memo } from "react";
import { ClauseCardProps } from "../../../types/ClauseCardProps";
import { ClauseCardMode } from "../../../types/enums";
import { FootnoteItem } from "../../../types/enums/FootnoteItem";
import { EllipsisTooltip } from "../../EllipsisTooltip/EllipsisTooltip";
import { useClauseFootnoteStyles } from "../styles/ClauseFootnote.styles";

type Props = Pick<ClauseCardProps, "footNoteItems" | "clause" | "mode" | "onOpenDocument">;
export const ClauseFootnote: React.FC<Props> = memo(({ footNoteItems, clause, mode, onOpenDocument }) => {
  const styles = useClauseFootnoteStyles();
  return (
    <>
      {footNoteItems?.includes(FootnoteItem.RELEVANCY) && (
        <div key={`footnote_relevance_${clause.clause_id}`}>
          <span className={styles.footNote}>
            {((clause.rankedSimilarity as number) * 100).toFixed(2) || "XX"}%{" "}
            {mode === ClauseCardMode.BROWSE ? "similar" : "relevant"}
          </span>
        </div>
      )}

      {footNoteItems?.includes(FootnoteItem.DOCUMENTS) && (
        <div key={`footnote_docTitle_${clause.clause_id}`}>
          <span className={styles.footNote}>
            {clause.sourceDocuments?.length ? (
              <>
                Found in{" "}
                <Link
                  className={clause.sourceDocuments.length > 1 ? styles.ellipsisTextWithOthers : styles.ellipsisText}
                  appearance="subtle"
                  onClick={() => onOpenDocument?.(clause.sourceDocuments[0], clause)}
                >
                  <EllipsisTooltip content={clause.sourceDocuments[0].doc_title}>
                    <strong>{clause.sourceDocuments[0].doc_title}</strong>
                  </EllipsisTooltip>
                </Link>
                {clause.sourceDocuments.length > 1 && (
                  <span className={styles.footNote}>
                    {" "}
                    and {clause.sourceDocuments.length - 1} other{" "}
                    {pluralize("document", clause.sourceDocuments.length - 1)}.
                  </span>
                )}
              </>
            ) : (
              <span>No document reference found.</span>
            )}
          </span>
        </div>
      )}
    </>
  );
});
